import React, { Component } from "react";
import $ from "jquery";
import * as handler from "../components/utils/handler";
import ReactHtmlParser from "react-html-parser";
import { DataService } from "../services/data.service";

const queryString = require("query-string");

class UserAuth extends Component {
  defaultLanguage = window["app-config"].defaultLang;
  runApp = window["app-config"].runApp;
  UI = window["app-config"].ui.userDetailsScreen;

  dataService = new DataService();
  state = {
    lang: {},
    isLoggin: true,
    showNextBtn: true,
    firstName: null,
    lastName: null,
    email: null,
    password: null,
  };
  username;
  password;

  componentDidMount() {
    // sessionStorage.setItem("isLogin",false)
    this.setLanguage();
  }

  setLanguage = () => {
    this.setState({ lang: handler.setTranslations() });
  };

  sendDataToParent = () => {
    this.props.loginDetails({
      username: this.username,
      password: this.password,
      isLoggin: this.state.isLoggin,
    });
  };

  sendSignupDetailsToParent = () => {
    this.props.signupDetails({
      firstName: this.state.firstName,
      surName: this.state.lastName,
      emailAddress: this.state.email,
      password: this.state.password,
      isLoggin: this.state.isLoggin,
    });
  };

  onUsernameChange = (e) => {
    this.username = e.target.value;
  };

  onPasswordChange = (e) => {
    this.password = e.target.value;
    this.setState({ password: e.target.value });
    if (
      this.username == "admin" &&
      this.password == "admin" &&
      this.state.isLoggin === true
    ) {
      this.sendDataToParent();
    }
  };

  onFirstNameChange = (e) => {
    this.setState({ firstName: e.target.value });
    this.sendSignupDetailsToParent();
  };

  onSurNameChange = (e) => {
    this.setState({ lastName: e.target.value });
    this.sendSignupDetailsToParent();
  };

  onEmailChange = (e) => {
    this.setState({ email: e.target.value });
    this.sendSignupDetailsToParent();
  };

  toggleForm = () => {
    this.setState({ isLoggin: !this.state.isLoggin });
  };

  renderSignup = () => {
    return (
      <>
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2 style={{ color: this.UI.headingColor }}>
              {this.state.lang.Signup}
            </h2>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col"></div>

              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.FirstName}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onFirstNameChange}
                  onBlur={this.sendSignupDetailsToParent}
                  type="text"
                  name="username"
                  maxLength={20}
                  placeholder={this.state.lang.FirstNamePlaceholder}
                  id="firstname-field"
                  className="sl__modal_form--input validate-text firstname"
                />
              </div>
              <div className="sl__modal_form-col"></div>
            </div>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col"></div>

              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.SurName}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onSurNameChange}
                  onBlur={this.sendSignupDetailsToParent}
                  type="text"
                  name="username"
                  maxLength={20}
                  placeholder={this.state.lang.SurNamePlaceholder}
                  id="firstname-field"
                  className="sl__modal_form--input validate-text firstname"
                />
              </div>
              <div className="sl__modal_form-col"></div>
            </div>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col"></div>

              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.EmailAddress}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onEmailChange}
                  onBlur={this.sendSignupDetailsToParent}
                  type="text"
                  name="username"
                  maxLength={20}
                  placeholder={this.state.lang.EmailAddressPlaceHolder}
                  id="firstname-field"
                  className="sl__modal_form--input validate-text firstname"
                />
              </div>
              <div className="sl__modal_form-col"></div>
            </div>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col"></div>

              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.password}
                  <span
                    className="estaric"
                    style={{
                      color: this.UI.requiredEstaricColor,
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onPasswordChange}
                  onBlur={
                    this.state.isLoggin === false
                      ? this.sendSignupDetailsToParent
                      : null
                  }
                  type="password"
                  name="password"
                  maxLength={20}
                  placeholder={this.state.lang.passwordPlaceholder}
                  id="surname-field"
                  className="sl__modal_form--input validate-text"
                />
              </div>

              <div className="sl__modal_form-col"></div>
            </div>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col">
                <a onClick={this.toggleForm}>{this.state.lang.LoginLink}</a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  render() {
    this.props.isLoggin(this.state.isLoggin);
    if (this.state.isLoggin === true) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2 style={{ color: this.UI.headingColor }}>
              {this.state.lang.Login}
            </h2>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col"></div>

              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.username}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onUsernameChange}
                  type="text"
                  name="username"
                  maxLength={20}
                  placeholder={this.state.lang.usernamePlaceholder}
                  id="firstname-field"
                  className="sl__modal_form--input validate-text firstname"
                />
              </div>
              <div className="sl__modal_form-col"></div>
            </div>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col"></div>

              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.password}
                  <span
                    className="estaric"
                    style={{
                      color: this.UI.requiredEstaricColor,
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onPasswordChange}
                  type="password"
                  name="password"
                  maxLength={20}
                  placeholder={this.state.lang.passwordPlaceholder}
                  id="surname-field"
                  className="sl__modal_form--input validate-text"
                />
              </div>

              <div className="sl__modal_form-col"></div>
            </div>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col">
                <a onClick={this.toggleForm}>{this.state.lang.Signup}</a>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        // <div className="sl__modal-inner">
        // <div className="sl__modal--content">
        //   <div className="sl__modal_form-row">
        //     <div className="sl__modal_form-col">
        this.renderSignup()
        //       </div>
        //     </div>
        //   </div>
        // </div>
      );
    }
  }
}

export default UserAuth;
